import React from 'react';
import Reflux from 'reflux';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import RcIf from 'rc-if';
export default class TopicSuggestions extends Reflux.Component {
    render () {
        const { topicSuggestions } = this.props;
        return <RcIf if={topicSuggestions && topicSuggestions.length > 0}>
          <div className='box'>
            <h5>Top5 relacionados</h5>
            <ul className='option-left option-border'>
              {
            topicSuggestions.map((topic) => {
                return (
                  <li key={topic._id}>
                    <Link type='button' to={'/topic/g_' + topic.title.replace(/ /g, '-')}>{topic.title}
                      <i className='fa fa-angle-right' aria-hidden='true' /></Link>
                  </li>
                );
            })
          }
            </ul>
          </div>
        </RcIf>;
    };
}

TopicSuggestions.propTypes = {
    topicSuggestions: PropTypes.array.isRequired
};



// WEBPACK FOOTER //
// ./src/components/topic/Suggested.js